import { reactive } from 'vue';

export function useSnack() {
  const snackbar = reactive<{
    open: boolean;
    text: string;
    color: 'success' | 'error' | 'info' | '';
  }>({
    open: false,
    text: '',
    color: '',
  });

  function show(text: string, color: 'success' | 'error' | 'info' = 'info') {
    snackbar.text = text;
    snackbar.color = color;
    snackbar.open = true;
  }

  function reset() {
    snackbar.open = false;
    snackbar.text = '';
    snackbar.color = '';
  }

  return { snackbar, show, reset };
}
